{
  "France": 20,
  "Belgium": 21,
  "Luxembourg": 17,
  "Germany": 19,
  "Switzerland": 8.1,
  "Italy": 22,
  "Spain": 21,
  "Andorra": 4.5,
  "Monaco": 20,
  "United Kingdom": 20
}
